import React from 'react'
import { object, number, func } from 'prop-types'
import { translate } from 'react-i18next'
import moment from 'moment/moment'

export const InterventionReportComponent = ({ intervention, index, t }) => {
  return <div className='interventionreport__section'>
    <p className='interventionreport__caption' key={index}>{t('common:visits:intervention_of', { date: moment.unix(intervention.interventionDate).format('dddd Do MMMM YYYY') })}</p>
    {
      intervention.proComments &&
      <div className='interventionreport__flex'>
        <p className='interventionreport__caption_procomments'>Description</p>
        <p className='interventionreport__procomments'>{intervention.proComments}</p>
      </div>
    }
    {
      intervention.durationInSeconds !== undefined &&
      <div className='interventionreport__flex'>
        <p className='interventionreport__caption_procomments'>Durée</p>
        <p className='interventionreport__procomments'>{moment.utc(intervention.durationInSeconds * 1000).format('HH[h]mm')}</p>
      </div>
    }
  </div>
}

InterventionReportComponent.propTypes = {
  t: func,
  intervention: object,
  index: number
}

export const InterventionReport = translate()(InterventionReportComponent)



// WEBPACK FOOTER //
// ./src/pages/demandes/maintenances/InterventionReport.js